import React, { useContext } from "react";
import AppContext from "../../../appContext";
import { TokenUtils } from "../../../shared/utils/TokenUtils";
import PageStateMessage from "../../../shared/components/generic/page-state-message/page-state-message";
import ApuracaoContent from "./apuracao-content";

const Apuracao = () => {
	const context = useContext(AppContext);

	if (!context.userSession) {
		return <PageStateMessage title="Carregando..." />;
	}

	const hasModuleAccess =
		TokenUtils.hasModuloPactoApproval();

	if (!hasModuleAccess) {
		return (
			<PageStateMessage
				title="Acesso Negado"
				description="Você não possui acesso ao módulo de Apuração de Parcelas do Pacto Rebates."
			/>
		);
	}

	return <ApuracaoContent />;
};

export default Apuracao;